import { Divider, DividerProps } from "@componentLibraryWrapper/divider";
import { appendClassName } from "@componentLibraryWrapper/common";
import './gridDivider.scss';

export interface GridDividerProps extends DividerProps {
}

const GridDivider = ({
  className,
  ...rest
}: GridDividerProps) => {
  return (
    <Divider
      {...rest}
      className={appendClassName('sm-griddivider', className)}
      orientation='vertical'/>
  )
}

export default GridDivider;